export default class AuthError extends Error {
  constructor(submessage) {
    super();
    this.name = 'AuthError';
    this.message = 'Usuário ou senha incorretos';
    this.submessage = submessage;
  }
}
